export const TEST_ID = 'interactionsSection';
